import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "../hooks/useAuth";

function RequireAuth({children}) {
    let {user} = useAuth();
    let location = useLocation();

    if (!user) {
        //console.log("Require Auth redirected, location:");
        return <Navigate to="/login" state={{from: location}} replace />;
    }

    //console.log("Require Auth, user", user);
    return children;
}

export default RequireAuth;